import { Injectable } from '@angular/core';
import {
    CanActivate,
    Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../storage.service';
import { isAdminRole, extractUserRole } from '../role.constants';

@Injectable({
    providedIn: 'root',
})
export class NoAuthGuard implements CanActivate {
    constructor(private _router: Router, private key: StorageService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | boolean | UrlTree {
        const userEnc = localStorage.getItem('user');
        const tokenEnc = localStorage.getItem('a_id');

        // Jika TIDAK ada token atau user data → belum login
        if (!userEnc || !tokenEnc) {
            console.log(
                'NoAuthGuard: User not authenticated, allowing access to sign-in'
            );
            return true;
        }
        try {
            const decrypted = this.key.decryptionAES(userEnc);
            const user = JSON.parse(decrypted);
            const roleName = extractUserRole(user?.role || user);

            // Redirect berdasarkan role
            if (isAdminRole(roleName)) {
                return this._router.createUrlTree(['/dashboard']);
            }

            return this._router.createUrlTree(['/user/home']);
        } catch (e) {
            console.error('NoAuthGuard: Decryption failed, allowing access', e);
            // Jika gagal decrypt, anggap belum login
            return true;
        }
    }
}

